export default function BusinessHero() {
  return (
    <section className="relative min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/a704de96aae836083b05fb10da343df8.jpg"
        alt="工商合作"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
        <div className="flex justify-center mb-5">
          <img
            src="https://public.readdy.ai/ai/img_res/2de05ae8-ab7f-40ca-afb5-96f93dc606a2.png"
            alt="Rappy me Logo"
            className="h-20 w-20 object-contain drop-shadow-lg"
          />
        </div>
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-600/80 text-white text-xs font-semibold mb-6 tracking-widest uppercase">
          <i className="ri-star-fill text-yellow-300" />
          Business Collaboration
        </div>
        <h1 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight" style={{ fontFamily: "'Noto Serif TC', serif" }}>
          工商洽談
          <span className="block text-red-400 mt-1">合作提案</span>
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-8">
          有意識的生活方式，跟我們一起活動享受當下。<br />
          多元業務項目，打造屬於你的品牌曝光舞台。
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="#biz-services"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-red-600 text-white font-semibold text-sm hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-briefcase-4-line" />
            查看服務項目
          </a>
          <a
            href="#biz-form"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-white text-white font-semibold text-sm hover:bg-white hover:text-gray-900 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-send-plane-line" />
            立即洽談合作
          </a>
        </div>
      </div>
    </section>
  );
}
